import React, { useState } from "react";
import { Button, Dialog, Stack, Typography } from "@mui/material";
import DialogDelete from "../Components/DialogDelete.jsx";
import { ErrorBar } from "../Components/ErrorBar.jsx";
import { API_Subscriber, APIs_data } from "./api.jsx";
import { deleteOptions, ftchPlus } from "./Account_urls.jsx";

const ProfileData = ({ form, open, onClose, }) => {
  const [errmsg, setErrmsg] = useState("")
  const [diaDelete, setDiaDelete] = useState(false)


  const deleteMyData = () => {
    var url = API_Subscriber + APIs_data;
    ftchPlus(url, deleteOptions)
      .then((json) => {
        setDiaDelete(false)
        onClose()
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onDeleteData = (e) => {
    setDiaDelete(true)
  }

  const okDeleteData = (e) => {
    deleteMyData()
  }


  return (
    <>
      <Dialog
        sx={{
          overflow: "scroll",
          "& .MuiDialog-container": {
            display: "inline-flex !important",
            //justifyContent: "flex-start",
            //alignItems: "flex-start",
            // overflow: "scroll",
            // mt: 30,
            // mx: 30,
            width: "100%",
            // minWidth: 1800,

          },
        }}
        //fullWidth={true}
        width="60%"
        maxWidth="100%"
        open={open}
        onClose={onClose}
      //disableEscapeKeyDown={true}
      >
        {form && (
          <Stack sx={{ mx: 4, my: 4 }} spacing={2}>

            <Stack sx={{ px: 4, py: 4 }} spacing={2}>
              <Typography sx={{ display: "flex", justifyContent: "flex-start", }} id="delete" variant="h6" gutterBottom>
                Data
              </Typography>

              <Typography sx={{ display: "flex", justifyContent: "flex-start", }} id="delete" variant="body1" gutterBottom>
                {"Clients: " + form.clients}
              </Typography>
              <Typography sx={{ display: "flex", justifyContent: "flex-start", }} id="delete" variant="body1" gutterBottom>
                {"Scenarios: " + form.scenarios}
              </Typography>
              <Stack direction="row" sx={{ pt: 10 }} spacing={2}>
                <Button variant="contained" color="secondary" onClick={onClose}>
                  Cancel
                </Button>
                <Button variant="contained" color="primary" onClick={onDeleteData}>
                  Delete all my data
                </Button>
              </Stack>
            </Stack>
          </Stack>
        )}

        <ErrorBar error={errmsg} />
      </Dialog >
      <DialogDelete
        show={diaDelete}
        onClose={() => setDiaDelete(false)}
        query="Do you wish to delete all your data"
        item="!! this is unrecoverable !!"
        deleteName="!! Delete All My Data !!"
        onDelete={okDeleteData}
      />
    </>
  );
};
export default ProfileData;
